import { useEffect, useState } from 'react'

type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => String(Math.max(value, 0)).padStart(2, '0')

export function useCountdown(durationHours = 24): TimeLeft {
  const [deadline] = useState<number>(() => Date.now() + durationHours * 60 * 60 * 1000)
  const [remaining, setRemaining] = useState<number>(() => deadline - Date.now())

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(deadline - Date.now())
    }, 1000)
    return () => window.clearInterval(id)
  }, [deadline])

  const totalSeconds = Math.max(Math.floor(remaining / 1000), 0)

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
  }
}
